import { DateTime } from "luxon";

export interface ShiftCode {
  code: string;               // Display code (e.g., "6-2 S")
  timeSlots: ShiftTimeSlot[]; // Time slots this code can be used in
  pay_class: 'UK' | 'FP';      // Pay class this code belongs to
}

interface ShiftTimeSlot {
  id: string;
  startTime: string;         // 24h format "HH:mm"
  endTime: string;           // 24h format "HH:mm"
  daysOfWeek: number[];      // 0-6 (0 = Sunday, 6 = Saturday)
  isDefault?: boolean;       // Whether this is the default time slot for this code
}

// All possible shift codes
export const SHIFT_CODES = {
  // Standard UK shifts (S)
  '6-2 S': {
    code: '6-2 S',
    pay_class: 'UK',
    timeSlots: [{
      id: '6-2 S',
      startTime: '06:00',
      endTime: '14:00',
      daysOfWeek: [0, 1, 2, 3, 4],
      isDefault: true
    }]
  },
  '2-10 S': {
    code: '2-10 S',
    pay_class: 'UK',
    timeSlots: [{
      id: '2-10 S',
      startTime: '14:00',
      endTime: '22:00',
      daysOfWeek: [0, 1, 2, 3, 4],
      isDefault: true
    }]
  },
  '10-6 S': {
    code: '10-6 S',
    pay_class: 'UK',
    timeSlots: [{
      id: '10-6 S',
      startTime: '22:00',
      endTime: '06:00',
      daysOfWeek: [0, 1, 2, 3, 4],
      isDefault: true
    }]
  },
  'OT13 S': {
    code: 'OT13 S',
    pay_class: 'UK',
    timeSlots: [
      {
        id: 'OT13 S-1',
        startTime: '06:00',
        endTime: '14:00',
        daysOfWeek: [0, 1, 2, 3, 4]
      },
      {
        id: 'OT13 S-2',
        startTime: '14:00',
        endTime: '22:00',
        daysOfWeek: [0, 1, 2, 3, 4]
      },
      {
        id: 'OT13 S-3',
        startTime: '22:00',
        endTime: '06:00',
        daysOfWeek: [0, 1, 2, 3, 4]
      }
    ]
  },
  'OT15 S': {
    code: 'OT15 S',
    pay_class: 'UK',
    timeSlots: [
      {
        id: 'OT15 S-1',
        startTime: '06:00',
        endTime: '18:00',
        daysOfWeek: [5, 6]
      },
      {
        id: 'OT15 S-2',
        startTime: '18:00',
        endTime: '06:00',
        daysOfWeek: [5, 6]
      }
    ]
  },
  'LAUNCH': {
    code: 'LAUNCH',
    pay_class: 'UK',
    timeSlots: [{
      id: 'LAUNCH-1',
      startTime: '06:00',
      endTime: '18:00',
      daysOfWeek: [5, 6]
    },
    {
      id: 'LAUNCH-2',
      startTime: '18:00',
      endTime: '06:00',
      daysOfWeek: [5, 6]
    },
    {
      id: 'LAUNCH-3',
      startTime: '06:00',
      endTime: '14:00',
      daysOfWeek: [0, 1, 2, 3, 4]
    },
    {
      id: 'LAUNCH-4',
      startTime: '14:00',
      endTime: '22:00',
      daysOfWeek: [0, 1, 2, 3, 4]
    },
    {
      id: 'LAUNCH-5',
      startTime: '22:00',
      endTime: '06:00',
      daysOfWeek: [0, 1, 2, 3, 4]
    }
    ]
  },
  'AM S': {
    code: 'AM S',
    pay_class: 'UK',
    timeSlots: [{
      id: 'AM S',
      startTime: '06:00',
      endTime: '18:00',
      daysOfWeek: [5, 6],
      isDefault: true
    }]
  },
  'PM S': {
    code: 'PM S',
    pay_class: 'UK',
    timeSlots: [{
      id: 'PM S',
      startTime: '18:00',
      endTime: '06:00',
      daysOfWeek: [5, 6],
      isDefault: true
    }]
  },

  // FP shifts
  '6-2 FP': {
    code: '6-2 FP',
    pay_class: 'FP',
    timeSlots: [{
      id: '6-2 FP',
      startTime: '06:00',
      endTime: '14:00',
      daysOfWeek: [0, 1, 2, 3, 4],
      isDefault: true
    }]
  },
  '2-10 FP': {
    code: '2-10 FP',
    pay_class: 'FP',
    timeSlots: [{
      id: '2-10 FP',
      startTime: '14:00',
      endTime: '22:00',
      daysOfWeek: [0, 1, 2, 3, 4],
      isDefault: true
    }]
  },
  '10-6 FP': {
    code: '10-6 FP',
    pay_class: 'FP',
    timeSlots: [{
      id: '10-6 FP',
      startTime: '22:00',
      endTime: '06:00',
      daysOfWeek: [0, 1, 2, 3, 4],
      isDefault: true
    }]
  },
  'OT4 FP': {
    code: 'OT4 FP',
    pay_class: 'FP',
    timeSlots: [
      {
        id: 'OT4 FP-1',
        startTime: '06:00',
        endTime: '14:00',
        daysOfWeek: [0, 1, 2, 3, 4]
      },
      {
        id: 'OT4 FP-2',
        startTime: '14:00',
        endTime: '22:00',
        daysOfWeek: [0, 1, 2, 3, 4]
      },
      {
        id: 'OT4 FP-3',
        startTime: '22:00',
        endTime: '06:00',
        daysOfWeek: [0, 1, 2, 3, 4]
      }
    ]
  },
  'OT WKND FP': {
    code: 'OT WKND FP',
    pay_class: 'FP',
    timeSlots: [
      {
        id: 'OT WKND FP-1',
        startTime: '06:00',
        endTime: '18:00',
        daysOfWeek: [5, 6],
        isDefault: true
      },
      {
        id: 'OT WKND FP-2',
        startTime: '18:00',
        endTime: '06:00',
        daysOfWeek: [5, 6]
      }
    ]
  },
  'OT WKND DUAL': {
    code: 'OT WKND DUAL',
    pay_class: 'FP',
    timeSlots: [
      {
        id: 'OT WKND DUAL-1',
        startTime: '06:00',
        endTime: '18:00',
        daysOfWeek: [5, 6],
        isDefault: true
      },
      {
        id: 'OT WKND DUAL-2',
        startTime: '18:00',
        endTime: '06:00',
        daysOfWeek: [5, 6]
      }
    ]
  },
  'COVER': {
    code: 'COVER',
    pay_class: 'UK',
    timeSlots: [{
      id: 'COVER',
      startTime: '06:00',
      endTime: '18:00',
      daysOfWeek: [0, 1, 2, 3, 4, 5, 6]
    }]
  }
} as Record<string, ShiftCode>;

export const SHIFT_CODE_OT_MAPPINGS = {
  '6-2 S': 'OT13 S',
  '2-10 S': 'OT13 S',
  '10-6 S': 'OT13 S',
  'OT13 S': 'OT13 S',
  'OT15 S': 'OT15 S',
  'LAUNCH': 'LAUNCH',
  'OT4 FP': 'OT4 FP',
  'OT WKND FP': 'OT WKND FP',
  'PERM OT WKND FP': 'PERM OT WKND FP',
  'TEMP OT WKND FP': 'TEMP OT WKND FP',
  'OT WKND DUAL': 'OT WKND DUAL',
  'COVER': 'COVER',
  '6-2 FP': 'OT4 FP',
  '2-10 FP': 'OT4 FP',
  '10-6 FP': 'OT4 FP',
  'AM S': 'OT15 S',
  'PM S': 'OT15 S',
} as Record<string, string>;

// Type for shift code keys
export type ShiftCodeKey = keyof typeof SHIFT_CODES;

export const SHIFT_CODES_KEYS = Object.keys(SHIFT_CODES) as ShiftCodeKey[];
export const OT_SHIFT_CODES_KEYS = ['OT13 S', 'OT15 S', 'LAUNCH', 'OT4 FP', 'PERM OT WKND FP', 'TEMP OT WKND FP', 'OT WKND DUAL', 'OT WKND FP'];

// Helper functions
export function isUKShiftCode(code: ShiftCodeKey): boolean {
  return SHIFT_CODES[code].pay_class === 'UK';
}

export function isFPShiftCode(code: ShiftCodeKey): boolean {
  return SHIFT_CODES[code].pay_class === 'FP';
}

export function getShiftCodesByPayClass(pay_class: 'UK' | 'FP'): ShiftCodeKey[] {
  return Object.keys(SHIFT_CODES).filter(code =>
    SHIFT_CODES[code as ShiftCodeKey].pay_class === pay_class
  ) as ShiftCodeKey[];
}

export function getDefaultTimeSlot(code: ShiftCodeKey): ShiftTimeSlot {
  return SHIFT_CODES[code].timeSlots.find(slot => slot.isDefault === true)
    ?? SHIFT_CODES[code].timeSlots[0];
}

export function getShiftTimeSlot(timeSlotId: string): ShiftTimeSlot | undefined {
  for (const shift_code of SHIFT_CODES_KEYS) {
    const timeSlot = SHIFT_CODES[shift_code].timeSlots.find(slot => slot.id === timeSlotId);
    if (timeSlot) return timeSlot;
  }
  return undefined;
}

export function getShiftCodeFromTimeSlotId(timeSlotId: string): ShiftCodeKey | undefined {
  for (const shift_code of SHIFT_CODES_KEYS) {
    const timeSlot = SHIFT_CODES[shift_code].timeSlots.find(slot => slot.id === timeSlotId);
    if (timeSlot) return shift_code;
  }
  return undefined;
}

// For sorting shift codes in a consistent order
export function getShiftCodeSortOrder(code: ShiftCodeKey): number {
  const sortOrder = Object.keys(SHIFT_CODES);
  return sortOrder.indexOf(code);
}

export interface ValidationResult {
  isValid: boolean;
  errorMessage?: string;
}

function getTimeInMinutes(time: string): number {
  const [hours, minutes] = time.split(':').map(Number);
  return hours * 60 + minutes;
}

export function validateShiftCode(shift: {
  shift_code?: ShiftCodeKey;
  start_date_time: DateTime;
  end_date_time: DateTime;
}, userPayClass?: 'UK' | 'FP'): ValidationResult {
  // Get the shift code details
  const shiftCodeDetails = SHIFT_CODES[shift.shift_code ?? ''];

  if (!shiftCodeDetails) {
    return { isValid: false, errorMessage: 'Shift code is required' };
  }

  // COVER is always valid
  if (shift.shift_code === 'COVER') {
    return { isValid: true };
  }

  // Validate pay class match
  if (shiftCodeDetails.pay_class !== userPayClass && userPayClass !== undefined) {
    return {
      isValid: false,
      errorMessage: `${userPayClass} users cannot be assigned ${shiftCodeDetails.pay_class} shift codes (${shift.shift_code})`
    };
  }

  // Temporarily allow OT15 S any time
  if (shift.shift_code === 'OT15 S') {
    return { isValid: true };
  }

  // Get minutes since midnight for the shift times
  const shiftStartMinutes = shift.start_date_time.hour * 60 + shift.start_date_time.minute;
  const shiftEndMinutes = shift.end_date_time.hour * 60 + shift.end_date_time.minute;

  // Determine if this is an overnight shift (end time < start time in the UTC day)
  const isOvernightShift = shift.end_date_time.toMillis() > shift.start_date_time.toMillis() && shiftEndMinutes < shiftStartMinutes;

  // Check if the shift is a partial overnight shift (e.g., 2am-6am)
  const isPartialOvernightShift = shiftStartMinutes < 6 * 60 && shiftEndMinutes <= 6 * 60;

  // Adjust the date to the work day (6am-6am)
  let workDay = shift.start_date_time;
  if (shiftStartMinutes < 6 * 60) { // Before 6am
    workDay = workDay.minus({ day: 1 });
  }

  const workDayOfWeek = workDay.weekday - 1; // Convert to 0 = Monday, 6 = Sunday

  // Find a matching time slot
  const matchingSlot = shiftCodeDetails.timeSlots.find(slot => {
    // Check if the day is valid
    if (!slot.daysOfWeek.includes(workDayOfWeek)) {
      return false;
    }

    // Convert slot times to minutes
    const slotStartMinutes = getTimeInMinutes(slot.startTime);
    const slotEndMinutes = getTimeInMinutes(slot.endTime);

    // Check if the slot is an overnight slot
    const isOvernightSlot = slotEndMinutes < slotStartMinutes;

    if (isOvernightSlot) {
      // For overnight slots
      if (isOvernightShift) {
        // Both shift and slot are overnight 
        return shiftStartMinutes >= slotStartMinutes && shiftEndMinutes <= slotEndMinutes;
      } else if (isPartialOvernightShift) {
        // Handle partial overnight shifts (e.g., 2am-6am)
        // These times are between midnight and 6am, which should match
        // with overnight shifts like 10pm-6am
        return shiftStartMinutes >= 0 && shiftEndMinutes <= slotEndMinutes;
      } else {
        // Regular shift within overnight slot timeframe
        // Normalize end minutes to compare properly
        const normalizedEndMinutes = shiftEndMinutes < slotStartMinutes ?
          shiftEndMinutes + 24 * 60 : shiftEndMinutes;

        return shiftStartMinutes >= slotStartMinutes &&
          normalizedEndMinutes <= (slotEndMinutes + 24 * 60);
      }
    } else if (isOvernightShift || isPartialOvernightShift) {
      // This is an overnight shift in a regular slot - invalid
      return false;
    } else {
      // Regular shift in regular slot
      return shiftStartMinutes >= slotStartMinutes && shiftEndMinutes <= slotEndMinutes;
    }
  });

  if (!matchingSlot) {
    return {
      isValid: false,
      errorMessage: `Invalid time or day for shift code ${shift.shift_code}`
    };
  }

  return { isValid: true };
}

export interface SupervisorShiftCode {
  code: string;               // Display code (e.g., "SP Weekend")
  timeSlots: ShiftTimeSlot[]; // Time slots this code can be used in
  pay_class: 'SP WKDAY' | 'SP WKND' | 'SP WKDAY FP'; // Pay class this code belongs to
}

export const SUPERVISOR_SHIFT_CODES = {
  // Standard UK shifts (S)
  'SP WKDAY': {
    code: 'SP WKDAY',
    pay_class: 'SP WKDAY',
    timeSlots: [{
      id: '6-2 S',
      startTime: '06:00',
      endTime: '14:00',
      daysOfWeek: [0, 1, 2, 3, 4],
      isDefault: true
    },
    {
      id: 'SP WKDAY',
      startTime: '14:00',
      endTime: '22:00',
      daysOfWeek: [0, 1, 2, 3, 4],
      isDefault: false
    },
    {
      id: 'SP WKDAY',
      startTime: '22:00',
      endTime: '06:00',
      daysOfWeek: [0, 1, 2, 3, 4],
      isDefault: false
    }
    ]
  },
  'SP WKND': {
    code: 'SP WKND',
    pay_class: 'SP WKND',
    timeSlots: [{
      id: 'SP WKND',
      startTime: '06:00',
      endTime: '18:00',
      daysOfWeek: [5, 6],
      isDefault: true
    }, {
      id: 'SP WKND',
      startTime: '06:00',
      endTime: '18:00',
      daysOfWeek: [5, 6],
      isDefault: true

    },
    ]
  },
  // Standard FP Shifts
  'SP WKDAY FP': {
    code: 'SP WKDAY FP',
    pay_class: 'SP WKDAY FP',
    timeSlots: [{
      id: '6-2 S',
      startTime: '06:00',
      endTime: '14:00',
      daysOfWeek: [0, 1, 2, 3, 4],
      isDefault: true
    },
    {
      id: 'SP WKDAY FP',
      startTime: '14:00',
      endTime: '22:00',
      daysOfWeek: [0, 1, 2, 3, 4],
      isDefault: false
    },
    {
      id: 'SP WKDAY FP',
      startTime: '22:00',
      endTime: '06:00',
      daysOfWeek: [0, 1, 2, 3, 4],
      isDefault: false
    }
    ]
  },
} as Record<string, SupervisorShiftCode>;